module.exports = __webpack_public_path__ + "static/img/3.e50ade4.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/1/2/zh/3.png
// module id = jvvk
// module chunks = 0